/**
 * Status display utilities for badges and labels.
 * Handles treatment plan/goal, assessment, and document statuses.
 */

const STATUS_COLORS = Object.fromEntries(
  [
    // Treatment plan
    ['active', 'green'],
    ['completed', 'blue'],
    ['on-hold', 'yellow'],
    // Episode of Care lifecycle (FHIR-aligned: planned, waitlist, active, onhold→follow-up, finished)
    ['planned', 'gray'],
    ['waitlist', 'yellow'],
    ['follow-up', 'blue'],
    ['finished', 'gray'],
    // Treatment goal
    ['in-progress', 'blue'],
    ['not-started', 'blue'],
    // Assessment
    ['In Progress', 'blue'],
    ['Stopped', 'gray'],
    ['Pending Review', 'yellow'],
    ['Completed', 'green'],
    ['completed', 'green'],
    ['Complete', 'green'],
    // Document / note status
    ['Stored', 'blue'],
    ['Shared', 'green'],
    ['Pending', 'yellow'],
    ['Signed', 'blue'],
    ['Draft', 'yellow'],
    ['Locked', 'blue'],
    ['final', 'green'],
  ] as Array<[string, string]>
) satisfies Record<string, string>;

const STATUS_LABELS = Object.fromEntries(
  [
    ['active', 'Active'],
    ['completed', 'Completed'],
    ['on-hold', 'On Hold'],
    // Episode of Care: display "Follow-up" (not "On hold") per FHIR onhold mapping
    ['planned', 'Planned'],
    ['waitlist', 'Waitlist'],
    ['follow-up', 'Follow-up'],
    ['finished', 'Finished'],
    ['in-progress', 'In Progress'],
    ['not-started', 'Not Started'],
    ['In Progress', 'In Progress'],
    ['Stopped', 'Stopped'],
    ['Pending Review', 'Pending Review'],
    ['Completed', 'Completed'],
    ['completed', 'Completed'],
    ['Stored', 'Stored'],
    ['Shared', 'Shared'],
    ['Pending', 'Pending'],
    ['Signed', 'Signed'],
    // Task status
    ['requested', 'Requested'],
    ['in-progress', 'In Progress'],
    ['cancelled', 'Cancelled'],
  ] as Array<[string, string]>
) satisfies Record<string, string>;

export function getStatusColor(status: string): string {
  const normalized = status?.trim() ?? '';
  return STATUS_COLORS[normalized] ?? 'blue';
}

export function formatStatusText(status: string): string {
  const normalized = status?.trim() ?? '';
  return STATUS_LABELS[normalized] ?? (normalized || '--');
}
